
const REQUIRED_ENV = [
    {
        name: 'REACT_APP_JAVA_API_URL',
        value: process.env.REACT_APP_JAVA_API_URL,
        purpose: 'Vectr Java API base URL — auth endpoints (getMe, logout, refresh)',
    },
    {
        name: 'REACT_APP_ESS_API_URL',
        value: process.env.REACT_APP_ESS_API_URL,
        purpose: 'ESS API base URL — every telemetry endpoint',
    },
    {
        name: 'REACT_APP_SOCKET_URL',
        value: process.env.REACT_APP_SOCKET_URL,
        purpose: 'ESS websocket gateway URL — live dashboards',
    },
    {
        name: 'REACT_APP_VECTR_PLATFORM_URL',
        value: process.env.REACT_APP_VECTR_PLATFORM_URL,
        purpose: 'Vectr platform URL — login / logout / 401 redirects',
    },
];

export const configErrors = REQUIRED_ENV
    .filter(({ value }) => !value)
    .map(({ name, purpose }) => ({ name, purpose }));


const apiBase = (base) => (base ? `${base}/api` : '');

const config = {
    apiUrl: apiBase(process.env.REACT_APP_JAVA_API_URL),
    socketUrl: process.env.REACT_APP_SOCKET_URL,
    essApiUrl: apiBase(process.env.REACT_APP_ESS_API_URL),
    vectrPlatformUrl: process.env.REACT_APP_VECTR_PLATFORM_URL,
    nodeApiUrl: apiBase(process.env.REACT_APP_NODE_WS_URL),
    fetchUrl: process.env.REACT_APP_NODE_API_URL
        ? process.env.REACT_APP_NODE_API_URL + '/getIntialData'
        : '',
    saasOrgName: process.env.REACT_APP_SAAS_ORG_NAME || "Vecmocon Technologies",
    authOrSidebarLogo: process.env.REACT_APP_Auth_OR_SIDEBARLOGO || "vecmocon/vecmocon-logo.png",
    authOrAuthfavIcon: process.env.REACT_APP_AuthFAVICON || "vecmocon/vecmocon-favicon.png",
    saasOrgContactUsUrl: process.env.REACT_APP_SaasOrgContactUsUrl || "#",
    tableRowsPerPage: process.env.REACT_APP_TABLE_ROWS_PER_PAGE || 100,
    gpsSpeedValidation: process.env.REACT_APP_GPS_SPEED_VALIDATION || 10,
    webpackMode: process.env.REACT_APP_WEBPACK_MODE || 'development',
    authFlagTime: Number(process.env.REACT_APP_AUTH_FLAGTIME) || 0,
    refreshTokenTime: Number(process.env.REACT_APP_REFRESH_TOKEN_TIME) || 0,
    apiCallTimeInterval: Number(process.env.REACT_APP_TIME_INTERVAL) || 0,
    apiCallTimeIntervalAfter8Jan: Number(process.env.REACT_APP_NEW_TIME_INTERVAL_AFTER_EIGHT) || 0,
    latestReportBatch: Number(process.env.REACT_APP_LATESTDATA_BATCH) || 30,
    maxConcurrentRequests: Number(process.env.REACT_APP_MAX_CONCURRENT_REQUESTS) || 1,
    maxConcurrentRequestsAfter8Jan: Number(process.env.REACT_APP_NEW_MAX_CONCURRENT_REQUESTS_AFTER_EIGHT) || 1,
    maxNumberOfCellInReport: Number(process.env.REACT_APP_MAX_NUMBER_OF_REPORT_CELL) || 600000,

    saasDashboardIdsForAllAssets: process.env.REACT_APP_SAAS_DASHBOARDSIDS || null,
    googleMapApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || null,
    fetchingBlfFile: process.env.REACT_APP_BLF_API || "",
    hardCodedAddressReportIds: process.env.REACT_APP_HARDCODED_ADDRESS_REPORTIDS || "",
    individualMosfetOrgIds: process.env.REACT_APP_INDIVIDUAL_MOSFET_CD_ORGIDS || "",
};

export default config;
